import React from "react";
import { motion } from "framer-motion";
import { Feather, ShieldCheck, Sun } from "lucide-react";

const pillars = [
  {
    icon: Feather,
    title: "Independence",
    desc: "Empowering seniors and families to maintain autonomy while quietly receiving the support they need.",
  },
  {
    icon: ShieldCheck,
    title: "Safety",
    desc: "Advanced monitoring and predictive intelligence to ensure wellbeing — around the clock, with respect.",
  },
  {
    icon: Sun,
    title: "Happiness",
    desc: "Creating joyful experiences through meaningful connection, calm reassurance and peace of mind.",
  },
];

export const Impact = () => {
  return (
    <section
      id="impact"
      className="relative py-24 md:py-32 bg-[#E6EBE6]"
      data-testid="impact-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="grid lg:grid-cols-12 gap-10 mb-16 items-end"
        >
          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.24em] uppercase text-sentivo-secondary mb-6">
              Our impact
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-sentivo-ink text-balance">
              Three quiet promises
              <span className="italic text-sentivo-accent"> we keep.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-lg text-sentivo-muted leading-relaxed">
            Behind every model, every signal and every gentle nudge — we are designing
            for three things that matter most.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {pillars.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                whileHover={{ y: -4 }}
                className="rounded-3xl bg-[#FAF9F6] p-10 border border-sentivo-line transition-shadow hover:shadow-md"
                data-testid={`impact-pillar-${p.title.toLowerCase()}`}
              >
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-sentivo-primary text-[#FAF9F6] mb-6">
                  <Icon size={22} strokeWidth={1.6} />
                </div>
                <h3 className="font-serif text-3xl text-sentivo-ink mb-3">{p.title}</h3>
                <p className="text-sentivo-muted leading-relaxed">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
